// extracted by mini-css-extract-plugin
export default {"root":"styles_root__El73v","primary":"styles_primary__34Fcr"};